module.exports = __webpack_public_path__ + "static/media/6-R-Smart Mini.c6a525fa.jpg";